import { render, staticRenderFns } from "./ProfileBanners.vue?vue&type=template&id=cbe564a8&scoped=true"
import script from "./ProfileBanners.vue?vue&type=script&lang=js"
export * from "./ProfileBanners.vue?vue&type=script&lang=js"
import style0 from "./ProfileBanners.vue?vue&type=style&index=0&id=cbe564a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe564a8",
  null
  
)

export default component.exports